<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="main">
            <div class="main-flex">
                <div class="main-title">
                    <div class="main-title-title">使用帮助</div>
                    <div class="main-title-phone">客服电话：<span v-text="phone"></span></div>
                </div>
                <div class="content-top">
                    <div class="main-content">
                        <span class="content-left">
                            1 操作说明
                        </span>
                        <span class="content-right">
                            1) 点击各功能按钮，可查看本用户的仪表内余额、进行充值、查询充值记录，以及能耗和费用明细查询；
                        </span>
                        <span class="content-right">
                            2) 需要多次充值时，请在第一次充值成功之后，再进行第二次充值；
                        </span>
                        <span class="content-right">
                            3) 完成充值操作后，可以“充值明细”功能中查看最新的充值记录；
                        </span>
                        <span class="content-right">
                            4) 操作完成后请及时退出系统。
                        </span>
                    </div>
                </div>
                <div class="content-bottom">
                <div class="main-content">
                    <span class="content-left" style="flex:0.5;">
                        2 常见问题
                    </span>
                    <span class="content-right">
                        <div class="content-right-top">
                            1) “充值明细”未查到充值后表内余额？
                        </div>
                        <div class="content-right-bottom">
                            系统正在充值支付过程中，尚未返回详细数据，请确认进行了正确的充值操作，并请稍等。
                        </div>
                    </span>
                    <span class="content-right">
                        <div class="content-right-top">
                            2) 充值缴费未成功怎么办？
                        </div>
                        <div class="content-right-bottom">
                            网络不畅时会造成充值失败或充值结果未返回，出现支付失败提示时，表示扣款未成功，请尝试进行再次充值操作；出现充值失败提示时，请先查询仪表内余额，如已经扣款但未充值成功，请及时与管理人员联系。
                        </div>
                    </span>
                    <span class="content-right">
                        <div class="content-right-top">
                            3) 已经完成充值，“余额查询”中表内余额未变更是什么原因？
                        </div>
                        <div class="content-right-bottom">
                            “余额查询”的数据刷新频率为1小时，需要在下次刷新数据时才能显示最新余额，可在“充值明细”中查看最新的充值结果。
                        </div>
                    </span>
                    <span class="content-right">
                        <div class="content-right-top">
                            4) 误充值、多充值了怎么退款？
                        </div>
                        <div class="content-right-bottom">
                            出现误充值、多充值时，请及时与管理员联系，在缴费窗口进行充抵退费操作。
                        </div>
                    </span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {selectCustomerById} from '@/api/customerUser'
  export default {
    name: "useHelp",
    data() {
      return {
        phone : "--"
      }
    },
    mounted() {
      selectCustomerById(this.$store.getters.customerId).then(response => {
        let customer=response.infoJson
        if(customer !== null && customer!==undefined && customer!==""){
          this.phone = customer.phone
        }else{
          this.$message({
            type: 'error',
            message: '客服电话查询失败'
          })
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '客服电话查询失败'
        })
      })
    }
  }
</script>

<style scoped>
    .main{
        position: absolute;
        left: 20%;
        right: 20%;
        top: 10%;
        bottom: 15%;
        width:60%;
        height:75%;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 2%;
    }
    .main-flex{
        display: flex;
        flex-direction:column;
        height:100%;
        width: 100%;
    }
    .main-title{
        text-align: center;
        flex: 1;
    }
    .main-content{
        flex: 1;
        display: flex;
        flex-direction:column;
    }
    .content-top{
        flex: 3;
        display: flex;
        flex-direction:column;
    }
    .content-bottom{
        flex: 5;
        display: flex;
        flex-direction:column;
    }
    .content-left{
        flex:0.8;
        font-weight: 600;
        text-align: center;
    }
    .content-right{
        flex:1;
    }
    .main-title-title{
        color: #059CAD;
        font-size: 24px;
        font-weight: 600;
    }
    .main-title-phone{
        float: right;
        color: #2357E2;
        font-weight: 600;
    }
    .content-right-top{
        font-weight: 600;
    }
    .content-right-bottom{
    }
</style>
